/**
 * CanvasHRuleRow — renderer targeting the `canvas` slot.
 * `rendererId = "canvas.hrule"`. Draws a horizontal rule at a
 * configured offset.
 */
import { Json } from "../../core/json.ts";
import { RendererRow } from "./renderer-row.ts";

/** The `canvas.hrule` painter row: draws a horizontal rule at a configured offset on its canvas. */
export class CanvasHRuleRow extends RendererRow {
  get offset(): number {
    return Json.number(this.attrs(), "offset") ?? 0;
  }

  get offsetType(): "pct" | "abs" {
    return Json.oneOf(this.attrs(), "offsetType", ["pct", "abs"]) ?? "abs";
  }
}
